import { Button } from '@/components/Button';
import { twMerge } from 'tailwind-merge';

interface CellContentWithRedirectProps {
  text: string;
  disabled?: boolean;
  textWrapperClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  showActionButton?: boolean;
  onClick?: () => void;
}

export const CellContentWithRedirect = ({
  text,
  disabled,
  textWrapperClassName,
  textClassName,
  iconClassName,
  showActionButton = true,
  onClick,
}: CellContentWithRedirectProps) => {
  return (
    <div className="flex items-center gap-3">
      <div
        className={twMerge('flex flex-1 justify-center', textWrapperClassName)}
      >
        <div
          className={twMerge(
            'text-sm font-semibold px-1.5 py-[2px] rounded-md bg-slate-100 dark-mode:bg-gray-200 dark-mode:text-gray-800 dark-mode:font-medium',
            textClassName
          )}
        >
          {text}
        </div>
      </div>
      {showActionButton && (
        <>
          <div className="font-semibold text-slate-300 dark-mode:text-gray-300">
            |
          </div>
          <div className={twMerge('', disabled && 'hover:cursor-not-allowed')}>
            <Button
              buttonClassName={twMerge(
                'px-1 h-7 rounded-lg shadow-md',
                disabled && 'bg-gray-400'
              )}
              disabled={disabled}
              leftIcon={
                <i
                  className={twMerge(
                    'ml-[0.5px] -mt-[1px] ki-outline ki-right-square text-white !text-lg',
                    iconClassName
                  )}
                />
              }
              onClick={onClick}
            />
          </div>
        </>
      )}
    </div>
  );
};
